import { Card, Typography, alpha } from '@mui/material';
import { ProductGroups } from 'enums';
import _ from 'lodash';
import React from 'react';
import { ProductMappedColors } from 'theme';
import { makeStyles } from 'tss-react/mui';

interface Props {
  productGroup?: ProductGroups;

  featureName: string;
  featureDescription?: string;

  action(): void;
}

const FeatureItem: React.FC<Props> = ({ productGroup, featureName, featureDescription, action }) => {
  const color = ProductMappedColors[productGroup || 'default'];
  const { classes } = useStyles({ color });

  const whiteProductLogo = '/dashboard/images/logos/product_logo_white.svg';

  return (
    <div className={classes.feature}>
      <Card className={classes.featureCard} elevation={0} onClick={action}>
        <div className={classes.arrow} />
        <img className={classes.logo} src={whiteProductLogo} alt="product logo" />
        <Typography className={classes.featureName}>{featureName}</Typography>
      </Card>
      {!_.isNil(featureDescription) ? <Typography className={classes.featureDescription}>{featureDescription}</Typography> : null}
    </div>
  );
};

const useStyles = makeStyles<{ color: string }>()((theme, { color }) => ({
  feature: {
    width: '100%',
    maxWidth: '460px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  featureCard: {
    cursor: 'pointer',
    width: '100%',
    borderRadius: theme.spacing(1.5),
    minHeight: '140px',
    padding: '24px 92px 20px 32px',
    background: color,
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      background: alpha(color, 0.9),
      transform: 'translateY(-2px)',
      boxShadow: `0 8px 24px ${alpha(color, 0.3)}`,
    },
  },
  featureName: {
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(22),
    lineHeight: 1.3,
  },
  featureDescription: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.secondary,
    padding: '0 4px',
    marginTop: theme.spacing(2),
    lineHeight: 1.6,
  },
  arrow: {
    position: 'absolute',
    top: '24px',
    left: 0,
    width: 0,
    height: 0,
    borderTop: '16px solid transparent',
    borderBottom: '16px solid transparent',
    borderLeft: `16px solid ${alpha(theme.palette.common.white, 0.7)}`,
  },
  logo: {
    position: 'absolute',
    top: '16px',
    right: '24px',
    width: '56px',
    height: '56px',
    opacity: 0.9,
  },
}));

export default FeatureItem;
